import { useCallback, useEffect, useRef, useState } from 'react';
import generalEndpoints from '../../../../api/services/generalEndpoints';

export const useFetchDocumentTypes = () => {
  const [loading, setLoading] = useState();
  const [docTypes, setDocTypes] = useState([]);
  const isMounted = useRef(true);

  const fetchAllDocumentTypes = useCallback(async () => {
    setLoading(true);
    if (docTypes.length === 0) {
      try {
        const response = await generalEndpoints.getDocumentTypes();
        if (response.status === 200) {
          if (isMounted.current) setDocTypes(response.data);
        }
      } finally {
        setLoading(false);
      }
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    fetchAllDocumentTypes().catch(console.error);
    return () => {
      isMounted.current = false;
    };
  }, [fetchAllDocumentTypes]);

  return {
    loading,
    documentTypes: docTypes,
  };
};
